// extracted by mini-css-extract-plugin
module.exports = {"capsuleNew":"Bp9aj","large":"SNR9O","smallSticky":"jGO8W","redStyle":"CbgnA","active":"JAvYf"};